'use strict';

(function () {
  if (blz.organizationId !== '45' && blz.organizationId !== '47') return;

  $('.customer-service .js-open-assistent').on('click', () => {
    $('.helpButtonEnabled').click();
  });
})();
